import { useState } from 'react';
// Styled by "../styles/TourButton.css";

function TourButton({ driver }) {
    const [showPopup, setShowPopup] = useState(false);

    return (<>
        <div className="tour-button-outer"
            onMouseLeave={() => setShowPopup(false)}
        >
            {showPopup ? 
                <div className="tour-button-popup-outer">
                    <button className="tour-button-popup-inner" onClick={() => driver.drive()}>
                        View Tour
                    </button>
                </div>
                : <></>
            }
            <button
                className="tour-button"
                onClick={() => driver.drive()}
                onMouseOver={() => setShowPopup(true)}
            >
                ?
            </button>
        </div>
    </>)
}

export {TourButton}